export default function(value) {
  if (!value) return "";
  value = value.toString();
  const encryptedValue = this.CryptoJS.AES.encrypt(value, this.SecretKey).toString();
  return encryptedValue;
}
